var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOliverIconColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9841 15.7734H0.935547V27.7053H12.9841V15.7734Z",
    fill: "#A568BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.081 15.7734H25.0325V27.7053H37.081V15.7734Z",
    fill: "#A1E663"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0326 3.84375H12.9841V15.7756H25.0326V3.84375Z",
    fill: "#FF8552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0326 27.7051H12.9841V39.6369H25.0326V27.7051Z",
    fill: "#1DB9CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0447 12.7912V0.859375C34.7001 0.859375 40.0932 6.20241 40.0932 12.7912H28.0447Z",
    fill: "#FFD026"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0325 39.6369V27.7051H37.081C37.081 34.2939 31.6879 39.6369 25.0325 39.6369Z",
    fill: "#47D2A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.935547 15.7756C0.935547 9.18463 6.33082 3.84375 12.9841 3.84375V15.7756H0.935547Z",
    fill: "#FF525F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.935547 27.7051H12.9841V39.6369C6.33082 39.6391 0.935547 34.296 0.935547 27.7051Z",
    fill: "#2797E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOliverIconColor);
export default __webpack_public_path__ + "static/media/Oliver-Icon-Color.996bafccc65ee56c573815074d05951a.svg";
export { ForwardRef as ReactComponent };